module.exports = "/dist/img/giftshopper_sample3.a8c95051.jpg";